module.exports = __webpack_public_path__ + "static/media/iiitk_logo.7b1060c3.png";